import React from 'react';
import {useLocation} from "react-router-dom";
import {matchPath} from "../../utils/reactRouterCompatibility";
import {Tooltip} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Link from "../../common/typography/Link";

const MenuNavLink = (props) => {
    const {icon, primary, path, tooltip, disabled, onClick} = props;
    const location = useLocation()

    //https://material-ui.com/guides/composition/#caveat-with-inlining
    const renderLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => (
                <Link ref={ref} to={path} {...linkProps} />
            )),
        [path],
    );

    // Extract path from props for React Router v7 matchPath
    const patternPath = props.path || '';
    
    // React Router v7 matchPath takes (pattern, pathname)
    const match = patternPath ? matchPath(patternPath, location.pathname) : null;
    const selected = !!match;

    return (
        <Tooltip title={tooltip} placement="right" arrow>
            <MenuItem button component={renderLink} selected={selected} disabled={disabled} onClick={onClick}>
                {icon && <ListItemIcon>{icon}</ListItemIcon>}
                <ListItemText primary={primary}/>
            </MenuItem>
        </Tooltip>
    );
};

export default MenuNavLink;